import { render, staticRenderFns } from "./WBgg.vue?vue&type=template&id=04213525&scoped=true"
import script from "./WBgg.vue?vue&type=script&lang=js"
export * from "./WBgg.vue?vue&type=script&lang=js"
import style0 from "./WBgg.vue?vue&type=style&index=0&id=04213525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04213525",
  null
  
)

export default component.exports